/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `24h` - 24-hour
 * * `12h` - 12-hour (AM/PM)
 * @export
 */
export const DefaultTimeFormatEnum = {
    _24h: '24h',
    _12h: '12h'
} as const;
export type DefaultTimeFormatEnum = typeof DefaultTimeFormatEnum[keyof typeof DefaultTimeFormatEnum];


export function instanceOfDefaultTimeFormatEnum(value: any): boolean {
    for (const key in DefaultTimeFormatEnum) {
        if (Object.prototype.hasOwnProperty.call(DefaultTimeFormatEnum, key)) {
            if (DefaultTimeFormatEnum[key as keyof typeof DefaultTimeFormatEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DefaultTimeFormatEnumFromJSON(json: any): DefaultTimeFormatEnum {
    return DefaultTimeFormatEnumFromJSONTyped(json, false);
}

export function DefaultTimeFormatEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultTimeFormatEnum {
    return json as DefaultTimeFormatEnum;
}

export function DefaultTimeFormatEnumToJSON(value?: DefaultTimeFormatEnum | null): any {
    return value as any;
}

export function DefaultTimeFormatEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DefaultTimeFormatEnum {
    return value as DefaultTimeFormatEnum;
}

